// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"363":"343b2a63","495":"b31b8fc8","939":"c2e483e1","999":"f1cf2ca5"}[chunkId] + ".chunk.js";
};